import { createStore } from 'vuex'

export default createStore({
  state: {
    stockTables: []
  },
  mutations: {
    saveStockTable(state, table) {
      state.stockTables.push(table)
    }
  },
  actions: {
    saveTable({ commit }, table) {
      commit('saveStockTable', table)
    }
  }
})
